import { ErrorHandler, Injectable, Injector} from '@angular/core';
import * as StackTraceParser from 'error-stack-parser';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) {
  }
 
  public handleError(error: any) {
    try {
      const name = error.name || null;
      const time = new Date().getTime();
      const location = this.injector.get(LocationStrategy);
      const url = location instanceof PathLocationStrategy ? location.path() : '';
      const status = error.status || null;
      const message = error.message || error.toString();
      var stack:any;
      var stackArray:any;
      var methodName : String;
      if(error!=null) {
        stack = error instanceof HttpErrorResponse ? null : StackTraceParser.parse(error).toString();
        stackArray = error instanceof HttpErrorResponse ? null : StackTraceParser.parse(error);
        if(stackArray.length>0){
          methodName = stackArray[0].functionName;
        }
      }
      const errorToSend = {name, time, url, status, message, methodName, stack};
      console.error(errorToSend);
      throw error;
    } catch(error){
      console.error(error);
      throw error;
    }
  }

}